export { default } from './IntegerInput';



// WEBPACK FOOTER //
// ./src/site-render/src/IntegerInput/index.js